<template>
	<div ref="view" id="search-permit" v-bind:class="getMainClass()">
		<searchInput :placeholder="placeholder" :results="results" :hasResults="hasResults"/>
	</div>
</template>

<script>

import searchInput from './search-input';

export default {
	name:'search-permit',
	data: function(){
		return {
			hasResults:false,
			placeholder:'Search permits by keyword',
			initSearch:false,
			boundsLoaded:false,
			boundsPrev:null,
			searchTermPrev:null
		}
	},
	components:{
		searchInput
	},
	computed: {
		searchTerm:function(){
			return this.$store.state.search.term;
		},
		searchType:function(){
			return this.$store.state.search.type;
		},
		results:function(){
			return this.$store.state.search.results;
		},
		bounds:function(){
			return this.$store.state.map.bounds;
		},
		mapLoaded:function(){
			return this.$store.state.map.loaded;
		},
		deviceType:function(){
			return this.$store.state.device.type;
		}
	},
	created:function(){
		// todo: check if this reroute is useful in a certain scenario - removed to clear out the search when directed from parcel to permit
		/* 
		if (this.searchTerm && this.$router.currentRoute.name === 'permits'){
			const route = {
				name: 'permitsSearch', 
				params:{
					search:this.searchTerm
				}
			};
			this.$router.replace(route);
			return;
		}
		*/
		if (this.$router.currentRoute.params.search && this.$router.currentRoute.params.search.length > 0){
			this.$store.dispatch('SEARCH_TERM_SET', {
				term:this.$router.currentRoute.params.search
			});
			return;
		}

		this.checkReady();
	},
	mounted: function (){
		this.handleResize();
		window.addEventListener('resize', this.handleResize);
	},
	beforeDestroy: function(){
		this.$store.dispatch('SEARCH_TERM_SET',{term:''});
	},
	destroyed: function (){
		window.removeEventListener('resize', this.handleResize);
		this.searchTermPrev = null;
		this.boundsPrev = null;
	},
	methods:{
		getMainClass:function(){
			if (this.deviceType === 'mobile'){
				return '';
			}
			return 'col-md-6 col-lg-5 col-xl-4 px-2';
		},
		checkSearch:function(){
			// compares cur search to prev, performs search if different
			if (this.searchTermPrev !== this.searchTerm || this.boundsPrev !== this.bounds || !this.results || this.searchType !== 'permit'){
				this.searchTermPrev = this.searchTerm;
				this.boundsPrev = this.bounds;
				this.search();
			} else if (this.results) {
				this.resultsPoi();
			}
		},
		checkReady:function(){
			if (this.mapLoaded && this.bounds){
				this.checkSearch();
			}
		},
		search:function(){
			let bbox = null;
			if (this.bounds){
				// The API expects a GeoJSON bounding box: min longitude, min latitude,
				// max longitude, max latitude.
				bbox = [this.bounds._sw.lng,this.bounds._sw.lat,this.bounds._ne.lng,this.bounds._ne.lat].join(',');
			}
			// if the route is on full permit view, bring the user back to permit list
			this.$store.dispatch('SEARCH', {
				query: this.searchTerm,
				type:'permit',
				bbox:bbox,
				doEmptySearch:true
			}).then((data)=>{

				let results = [];
	         data.permits.map((permit)=>{
	            let found = false;
	            results.map((p,i)=>{
	               if (p.parcelId === permit.parcelId){
	                  found = true;
	                  p.number++;
	               }
	            });
	            if (!found){
	               permit.number = 1;
	               results.push(permit);
	            }
	         });

            this.$store.dispatch('SEARCH_RESULTS_SET', {results:data.permits});

         	this.resultsPoi(results);

			}).catch((e)=>{
				console.error(e);
			});
		},

		handleResize:function(){
			if (!this.$refs['view']) return;
			if (this.deviceType !== 'mobile'){
				let w = this.$refs['view'].offsetWidth+60; // width of nav bar + margin
				this.$store.dispatch('MAP_LEFT_MARGIN_SET', {leftMargin:w});
			} else {
				this.$store.dispatch('MAP_LEFT_MARGIN_SET', {leftMargin:0});
			}
		},

		resultsPoi:function(){
			if (!this.mapLoaded || !this.results) return;
			let poi = [];
			this.results.map((permit)=>{

				let description = permit.number+' permit'+((permit.number > 1)? 's':'');
				let title;
				//	build our title link if we have a parcelId. not all permits have an APN (i.e. right of way grading)

				title = permit.typeRaw;

				//	build our geojson for the point and add it to our features array
				const obj = {
					id:permit.id,
					properties:{
						type:'permit',
						description:description,
						permitId:permit.id,
						parcelId:permit.parcelId,
						resource_id:permit.id,
						route:{
							name: 'permit', 
							params:{
								id:permit.id
							}
						},
						title,
					},
					geometry:permit.geom
				};

				poi.push(obj);
			});

			this.$store.dispatch('MAP_POI_SET', poi);				
		},
	},

	watch: {
		'$route':function(newRoute,oldRoute){
			if (newRoute.params.search && newRoute.params.search !== this.searchTerm){
				this.$store.dispatch('SEARCH_TERM_SET', {
					term:newRoute.params.search
				});
				return;
			}
			this.checkReady();
		},
		bounds: function(newBounds, oldBounds){
			this.checkReady();
		},
		searchTerm: function(newTerm, oldTerm){
			if (this.$router.currentRoute.params.search !== newTerm && newTerm.length > 0){
				const route = {
					name: 'permitsSearch', 
					params:{
						search:newTerm
					}
				};
				this.$router.replace(route);
				return;
			} else if (this.$router.currentRoute.params.search !== newTerm) {
				const route = {
					name: 'permits',
					params:{}
				};
				this.$router.replace(route);
				return;
			}
			this.checkReady();
		},
		mapLoaded:function(){
			this.checkReady();
		}
	}
}
</script>

<style>
.desktop #search-permit {
   position:fixed;
	left:55px;
	top:0.5rem;
	z-index:1000;
}
</style>



// WEBPACK FOOTER //
// src/components/search/search-permit.vue